import { useEffect } from 'react';
import { inputType } from '../components/SterlingBVAROI';
import { AvgOOSRate } from '../constants/defaults';
export interface priceProps {
  partNumber: string;
  pricingIndicator: string;
  pricingModel: number;
  scaleQtyPrice: [
    {
      qty: number;
      price: number;
    },
  ];
}

interface rangeType {
  incOnlineSales: number;
  incStoreSaleReduce: number;
  reduceReturn: number;
  reduceMarkdownCosts: number;
  reduceShippingCosts: number;
}

export const setPrice = (
  input: inputType,
  setIncreaseOnlineSalesTotal: React.Dispatch<React.SetStateAction<number>>,
  setIncreaseStoreSalesTotal: React.Dispatch<React.SetStateAction<number>>,
  setReduceReturnsTotal: React.Dispatch<React.SetStateAction<number>>,
  setReduceMarkDownCostTotal: React.Dispatch<React.SetStateAction<number>>,
  setReduceShippingCostTotal: React.Dispatch<React.SetStateAction<number>>,
  setEstimatedSavings: React.Dispatch<React.SetStateAction<number>>,
  setIncreaseInSaleTotal: React.Dispatch<React.SetStateAction<number>>,
  setReductionInCostsTotal: React.Dispatch<React.SetStateAction<number>>,
  setAdditionalProfitTotal: React.Dispatch<React.SetStateAction<number>>,
  range: rangeType,
  rangeIndex: number,
) => {
  useEffect(() => {
    const calcEstAnnualSales =
      input.estimatedAnnualSale -
      (input.onlineSalePercentage / 100) * input.estimatedAnnualSale;
    const calcPctSale =
      (input.onlineSalePercentage / 100) * input.estimatedAnnualSale;
    const calcAvgMarkDownCost =
      (input.estimatedAnnualSale * input.avgMarkDownCost) / 100;
    const calcAvgShippingCost = (calcPctSale * input.avgShippingCost) / 100;
    const totalOnlineSales = Math.round(calcPctSale * range.incOnlineSales);
    const totalStoreSales = Math.round(
      calcEstAnnualSales *
        AvgOOSRate *
        (calcPctSale / input.estimatedAnnualSale) *
        range.incStoreSaleReduce,
    );
    const totalReduceReturn = Math.round(calcPctSale * range.reduceReturn);
    const totalReduceMarkDownCost = Math.round(
      calcAvgMarkDownCost *
        (input.onlineSalePercentage / 100) *
        range.reduceMarkdownCosts,
    );
    const totalReduceShippingCost = Math.round(
      calcAvgShippingCost * range.reduceShippingCosts,
    );
    const EstimatedSavings = Math.round(
      totalOnlineSales +
        totalStoreSales +
        totalReduceReturn +
        totalReduceMarkDownCost +
        totalReduceShippingCost,
    );
    const additionaProfit = Math.round(
      totalOnlineSales * (input.industryAvgProfit / 100) +
        totalStoreSales * (input.industryAvgProfit / 100) +
        totalReduceReturn +
        totalReduceMarkDownCost +
        totalReduceShippingCost,
    );
    setIncreaseOnlineSalesTotal(
      Math.round(totalOnlineSales * (input.industryAvgProfit / 100)),
    ),
      setIncreaseStoreSalesTotal(
        Math.round(totalStoreSales * (input.industryAvgProfit / 100)),
      ),
      setReduceReturnsTotal(totalReduceReturn),
      setReduceMarkDownCostTotal(totalReduceMarkDownCost),
      setReduceShippingCostTotal(totalReduceShippingCost),
      setIncreaseInSaleTotal(
        totalOnlineSales + totalStoreSales + totalReduceReturn,
      );
    setReductionInCostsTotal(totalReduceMarkDownCost + totalReduceShippingCost);
    setEstimatedSavings(EstimatedSavings);
    setAdditionalProfitTotal(additionaProfit);
  }, [input, rangeIndex]);
};
